import { useState, useCallback } from 'react';
import { useGetTransportQuery, type DashboardOptions } from '@/entities/dashboard';

export function useTransportOverview() {
  const [options, setOptions] = useState<DashboardOptions>({
    metric: 'W',
    group: 'D',
    period: 'L6M',
    status: 'DI'
  });

  const { data, isLoading, error } = useGetTransportQuery(options);

  const updateOption = useCallback((key: keyof DashboardOptions, value: string) => {
    setOptions((prev) => ({ ...prev, [key]: value }));
  }, []);

  const formatValue = useCallback((value: number, metric?: string): string => {
    if (metric === 'W') {
      return `${(value / 1000).toFixed(1)} mt`;
    }
    if (metric === 'V') {
      return `${value.toFixed(1)} m³`;
    }
    return value.toLocaleString();
  }, []);

  const formattedStats = data
    ? {
        totalShipments: data.totalNumberOfShipments.toLocaleString(),
        totalTransported: formatValue(data.totalTransported, options.metric),
        totalDestinations: data.totalNumberOfDestinations.toString(),
        totalLoss: formatValue(data.totalLoss, options.metric),
        totalDamage: formatValue(data.totalDamage, options.metric)
      }
    : null;

  return {
    data,
    formattedStats,
    isLoading,
    error,
    options,
    updateOption
  };
}
